// ----------------------------------------------------------------------------
// Component: Yotpo Rewards Products
// ----------------------------------------------------------------------------
//
// Loads the reward products section after the Yotpo content has loaded.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------


// Styles
import './_yotpo-rewards-products.scss';

const observeYotpoContent = () => {
    const yotpo_rewards_section = document.querySelector('#yotpo_rewards_section');

    if (!yotpo_rewards_section) {
        return;
    }

    // Observe main for mutations
    const targetNode = document.querySelector('.main');

    // Look for children added to the main node
    const config = { attributes: false, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
        if (mutation.type === "childList" && mutation.target.querySelector('.yotpo-widget-hero-section')) {
            observer.disconnect();
            yotpo_rewards_section.classList.add('yotpo-rewards-section--show');
        }
    }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
}


document.addEventListener('DOMContentLoaded', function(event) {
    observeYotpoContent();
})
